import { getPbCrypto } from './crypto'; 
import { getEncryptedStorage } from './encrypted-storage';

export default {
  getPbCrypto,
  getEncryptedStorage,
};